module.exports = __webpack_public_path__ + "static/media/like.dbc19a9e.svg";